import React, { useState, useEffect } from "react";
import CommonHeader from "../components/Onboarding/CommonHeader";
import SegmentDivider from "../components/MemberWantAd/SegmentDivider";
import MyDrafts from "../components/Common/MyDrafts";
import { useNavigate } from "react-router-dom";
import { AGENT_WANTAD_KEY } from "../constants/common";
import { getMyDraft, getWantAdById } from "../services/wantAdService";
import { pageURLs } from "../constants/pageURLs";
import { getUserId, checkTutorialDisplayStatus } from "../helpers/common";



const AgentCreateOrEditWantAdDraftListing = (props) => {

  const navigate = useNavigate()
  const [myDrafts, setMyDrafts] = useState(null);

  useEffect(() => { //Need to show want add onboard very first time
    let DisplayWantAddOnboard = checkTutorialDisplayStatus(6); //Want add onboard display
    if (DisplayWantAddOnboard) {
      navigate(pageURLs.gitchaMemberWelcome)
    }
  }, []);

  useEffect(() => {
    localStorage.removeItem(AGENT_WANTAD_KEY);
    const userId = getUserId();
    getMyDraft()
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (responseResult && responseResult.length !== 0) {
          setMyDrafts(responseResult);
        } else {
          navigate(pageURLs.agentCreatewantad)
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  }, []);

  const handleDraftItemClick = async (requestPayLoad) => {
    let wantAdId = requestPayLoad.selectedId;
    if (wantAdId) {
      await getWantAdById(wantAdId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            localStorage.setItem(AGENT_WANTAD_KEY, JSON.stringify(responseResult));
            navigate(pageURLs.agentCreatewantad)
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  const loadDrafts = () => {
    if (myDrafts) {
      const myDraftList =

        myDrafts?.map((md) => {
          const wantAdId = _.get(md, "Want_ad_Id");
          const CompletedPercentage = _.get(md, "CompletedPercentage", "");
          const adTypeId = _.get(md, "Buy_or_Rent", "");
          const Current_Step = _.get(md, "Current_Step", "");
          let lastUpdatedDate = new Date(_.get(md, "LastUpdatedTS", ""));
          let formattedDate = [('0' + (lastUpdatedDate.getMonth() + 1)).slice(-2),
          ('0' + lastUpdatedDate.getDate()).slice(-2),
          lastUpdatedDate.getFullYear()].join('/');
          let adType = ''
          if (adTypeId === 1) {
            adType = 'Buy'
          } else if (adTypeId === 2) {
            adType = 'Rent (Long-term)'
          } else if (adTypeId === 3) {
            adType = 'Rent (Short-term)'
          }
          let clientName;
          if (_.get(md, "ClientFirstName") && _.get(md, "ClientLastName")) {
            clientName = _.get(md, "ClientFirstName") + " " + _.get(md, "ClientLastName");
          } else if (_.get(md, "ClientFirstName")) {
            clientName = _.get(md, "ClientFirstName");
          }


          return (
            <MyDrafts
              key={wantAdId}
              itemId={wantAdId}
              CompletedPercentage={CompletedPercentage}
              adType={adType}
              Current_Step={Current_Step}
              setDraftSelectedItem={handleDraftItemClick}
              latUpdatedDate={formattedDate}
              clientName={clientName}
              isFromWantAd={true}
            />
          );
        });

      return myDraftList;
    }

  };

  return (
    <div className="outer-wrap position-relative mw-1168">
      <CommonHeader />
      {myDrafts &&
        <div className="row">
          <div className="col-md-12">
            <div className="edit-want-ad-wrap mw-640">
              <h2>Create Want-ad</h2>
              <h6 className="mb-40">Help your clients find exactly what the're looking for. </h6>
              <div className="create-new-wantad-wrap mb-3" onClick={() => navigate("/agent-create-want-ad")}>
                <label className="radio-wrap">
                  <input name="SELL4" type="radio" value="false" />
                  <span>
                    <div className="timing-wrap-info">
                      <h2 className="pb-0">Create New Want-ad</h2>
                    </div>
                  </span>
                </label>
              </div>

              {/* <a role="button"
                href={void 0} className="create-new-btn mb-3" onClick={() => navigate("/agent-create-want-ad")}>
                <span className="create-plus-icon">
                  <img src={CreatePlusIcon} />
                </span>
                Create New Want-ad
              </a> */}
              {myDrafts &&
                <>
                  <SegmentDivider />
                  <div className="my-drafts-sec">
                    <h2 className="mt-3">My Drafts</h2>
                    {loadDrafts()}
                  </div>


                </>}
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default AgentCreateOrEditWantAdDraftListing;
